// test245
(245 && 0);
